import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StrideSchoolSectionSkillLevel } from '@mira-avant/mtlibs';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

@Component({
	selector: 'app-section-skill-distribution-bar',
	imports: [CommonModule, NzTooltipModule],
	standalone: true,
	templateUrl: './section-skill-distribution-bar.html',
	styleUrl: './section-skill-distribution-bar.scss',
})
export class SectionSkillDistributionBar implements OnChanges {
	@Input('levels') public levels: StrideSchoolSectionSkillLevel[] = [];
	@Input('skill') public skill: string = 'Unknown';
	@Input('average') public average: number | undefined;
	public normalizedLevels: StrideSchoolSectionSkillLevel[] = [];

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['levels'] && this.levels?.length) {
			this.normalizeLevels();
		}
	}

	private normalizeLevels(): void {
		this.normalizedLevels = this.levels;
	}

	public getTooltip(): string {
		const skillCapitalized = this.skill.charAt(0).toUpperCase() + this.skill.slice(1);
		//return a string like so: "Reading: Level 1: 20%, Level 2: 30%, Level 3: 50%"
		let tooltip = `${skillCapitalized}: `;

		tooltip += this.normalizedLevels.map(l => `Level ${l.level}: ${l.percent.toFixed(1)}%`).join(', ');

		return tooltip;
	}
}
